import Deco from 'images/break/art-deco_long.png'
import Floral from 'images/break/floral.png'
import Flourish from 'images/break/flourish.png'

const styles = { width: '100%', margin: '32px auto', display: 'block' }

export const DecoBreak = () => <img src={Deco} alt="" style={styles} />
export const FloralBreak = () => <img src={Floral} alt="" style={styles} />
export const FlourishBreak = () => <img src={Flourish} alt="" style={{...styles, width: 'auto'}} />
